import { render, staticRenderFns } from "./addFormZhong.vue?vue&type=template&id=c3b85ca2&scoped=true&"
import script from "./addFormZhong.vue?vue&type=script&lang=js&"
export * from "./addFormZhong.vue?vue&type=script&lang=js&"
import style0 from "./addFormZhong.vue?vue&type=style&index=0&id=c3b85ca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b85ca2",
  null
  
)

export default component.exports